/**
 * 运输段模式(L0-03)。**单点定义在这里,三端引用。**
 *
 * 本期每单只生成一条 `air` 段:客户明确否掉了多段派单(N-01),
 * 陆运与海运由承运商自己包圆,四个端统一呈现为「运输中」。
 *
 * road / sea 是**预留取值**,当前一行代码都不会产出它们。
 * 留着的理由写在 L0-03 里:leg 子表现在的成本是一张表加一次 join,
 * 以后真要拆段的成本是动数据模型主干加四个端重做 —— 不对称到这个程度,预留是唯一理性选择。
 *
 * 「预留」必须是可验证的,不能是一句口头承诺:
 * probes/invariants.mjs 的「每个订单的运输段状态与订单状态一致」断言每单恰好一条段、
 * 且 mode 恒为 air。哪天真的开始生成 road/sea,那条等式会当场红 —— 那时是有意为之,改等式。
 */
export const TRANSPORT_MODE = ['road', 'air', 'sea'] as const

export type TransportMode = (typeof TRANSPORT_MODE)[number]

export function isTransportMode(x: unknown): x is TransportMode {
  return typeof x === 'string' && (TRANSPORT_MODE as readonly string[]).includes(x)
}
